export const EPHEMERAL_KEY_EXPIRATION = 300_000; // 5 minutes in milliseconds
